var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{staticClass:"multiselect",attrs:{"value":_vm.selectedRules,"placeholder":_vm.translations.placeholder,"options":_vm.availableRules,"track-by":"name","label":"description","multiple":true,"showPointer":false,"searchable":false,"custom-label":_vm.customLabel},on:{"select":_vm.onSelect,"remove":_vm.onRemove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }